import sanitizeHtml from 'sanitize-html'

export const SANITIZATION_CONFIG = {
  basic: {
    allowedTags: [...sanitizeHtml.defaults.allowedTags, 'span'],
    allowedAttributes: {
      a: ['href', 'target', 'style'],
      '*': ['style', 'class'],
      li: ['data-list'],
    },
    allowedStyles: {
      '*': {
        'text-align': [/^left$/, /^right$/, /^center$/, /^justify$/],
      },
      'img': {
        'padding': [/.*/],
        'padding-top': [/.*/],
        'padding-right': [/.*/],
        'padding-bottom': [/.*/],
        'padding-left': [/.*/],
        'margin': [/.*/],
        'margin-top': [/.*/],
        'margin-right': [/.*/],
        'margin-bottom': [/.*/],
        'margin-left': [/.*/],
        'border': [/.*/],
        'width': [/.*/],
        'height': [/.*/]
      },
      'span': {
        '.*': [/.*/]
      }
    }
  },
  advanced: {
    allowedTags: [...sanitizeHtml.defaults.allowedTags, 'span', 'img'],
    allowedAttributes: {
      a: ['href', 'target', 'style'],
      '*': ['style', 'class'],
      li: ['data-list'],
      img: ['src', 'alt', 'width', 'height', 'data-id', 'class', 'style'],
    },
    allowedStyles: {
      '*': {
        'text-align': [/^left$/, /^right$/, /^center$/, /^justify$/],
        'font-family': [/^.*$/],
        'font-size': [/.*/],
        'color': [/.*/],
        'font-weight': [/.*/],
        'line-height': [/.*/],
        'font-style': [/.*/],
        'text-decoration': [/.*/],
        'background-color': [/.*/],
        'background': [/.*/],
        'padding': [/.*/],
        'padding-top': [/.*/],
        'padding-right': [/.*/],
        'padding-bottom': [/.*/],
        'padding-left': [/.*/],
        'margin': [/.*/],
        'margin-top': [/.*/],
        'margin-right': [/.*/],
        'margin-bottom': [/.*/],
        'margin-left': [/.*/],
        'border': [/.*/],
        'width': [/.*/],
        'height': [/.*/],
        'display': [/.*/],
        'position': [/.*/],
        'top': [/.*/],
        'right': [/.*/],
        'bottom': [/.*/],
        'left': [/.*/],
        'z-index': [/.*/],
        'opacity': [/.*/],
        'transform': [/.*/],
        'letter-spacing': [/.*/],
        'word-spacing': [/.*/],
        'text-transform': [/.*/],
        'text-shadow': [/.*/],
        'box-shadow': [/.*/],
        'border-radius': [/.*/],
        'vertical-align': [/.*/]
      },
      'img': {
        'padding': [/.*/],
        'padding-top': [/.*/],
        'padding-right': [/.*/],
        'padding-bottom': [/.*/],
        'padding-left': [/.*/],
        'margin': [/.*/],
        'margin-top': [/.*/],
        'margin-right': [/.*/],
        'margin-bottom': [/.*/],
        'margin-left': [/.*/],
        'border': [/.*/],
        'width': [/.*/],
        'height': [/.*/]
      },
      'span': {
        '.*': [/.*/]
      }
    }
  }
}

export const TRANSFORM_TAGS = {
  'li': function(tagName, attribs) {
    if (attribs['t'] === 'b') {
      delete attribs['t']
      attribs['data-list'] = 'bullet'
    } else if (attribs['t'] === 'n') {
      delete attribs['t']
      attribs['data-list'] = 'ordered'
    }
    return {
      tagName,
      attribs
    }
  }
}

export function getSanitizationConfig(advanced = false) {
  return {
    ...SANITIZATION_CONFIG[advanced ? 'advanced' : 'basic'],
    transformTags: TRANSFORM_TAGS
  }
}